module.exports = __webpack_public_path__ + "static/media/right_output.cebc9e3b.png";